interface GuideBlockProps {
  items: string[];
  label: string;
  markerClassName: string;
}

export const GuideBlock = ({
  items,
  label,
  markerClassName,
}: GuideBlockProps) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-2.5">
      <p className="text-sm font-semibold">{label}</p>
      {items.map((item, index) => (
        <div className="flex items-start gap-3" key={`${label}-${index}`}>
          <span
            className={`mt-1 inline-block h-2 w-2 shrink-0 rounded-full ${markerClassName}`}
          />
          <p className="text-sm text-uw-gray-9">{item}</p>
        </div>
      ))}
    </div>
  );
};
